import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserProvider } from './context/UserContext';
import { AuthProvider } from './context/AuthContext';
import { registrarServiceWorker } from './pwa/registrarServiceWorker';
import { iniciarCapturaInstalacion } from './pwa/instalacionApp';

// PWA: instalable y usable sin conexión
iniciarCapturaInstalacion();
registrarServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<AuthProvider>
			<UserProvider>
				<App />
			</UserProvider>
		</AuthProvider>

	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
